import MandatoryDocumentPage from './MandatoryDocumentPage';

const MandatoryDocumentConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'mandatory-document',
      element: <MandatoryDocumentPage />,
    },
  ],
};

export default MandatoryDocumentConfig;
